import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { useAreaFilter } from "./useAreaFilter";
import { useRoundFilter } from "./useRoundFilter";
import { usePeriodFilter } from "./usePeriodFilter";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";

interface ShoppingToolsFiltersProps {
  showRound: boolean;
  showPeriod: boolean;
}

export function useShoppingToolsFilters({
  showRound,
  showPeriod,
}: ShoppingToolsFiltersProps) {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.SHOPPING_TOOLS_FILTERS
  );

  const useShoppingToolsDataFilters = (values: FilterValue[]) => [
    useAreaFilter(),
    useRoundFilter(showRound),
    usePeriodFilter(showPeriod, values),
  ];

  return {
    useFiltersFactory: useShoppingToolsDataFilters,
    filterValues,
    setFilterValues,
  };
}
